import { createSelector } from '@ngrx/store';

import { ErrorType } from '@core/api';

import { getErrorState } from './main.selectors';

export const getPageError = createSelector(getErrorState, (state) => {
  return state?.level === ErrorType.PAGE ? state?.error : undefined;
});

export const getActionError = createSelector(getErrorState, (state) => {
  return state?.level === ErrorType.ACTION ? state?.error : undefined;
});
